module.exports = __webpack_public_path__ + "images/emoji/herb.fe329e8bdbe5fecc686b.png";